module.exports = __webpack_public_path__ + "images/landing/banner/help-img-3b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-3b.png
// module id = 9uog
// module chunks = 154